/**
 * The locked vendor STORE-TYPE taxonomy — the dropdown a vendor picks from at
 * registration (§1B apply form). Rod-approved 2026-06-25; these are their OWN
 * list, NOT a mapping onto product departments. Order is alphabetical by label
 * with "Other" pinned last; selecting "Other" routes to a harder manual review.
 *
 * `color` is the chip tint borrowed from the consumer departmentConfig palette
 * (or an off-palette pick where no department fits) — used wherever a store-type
 * chip is rendered.
 */
export interface StoreType {
  slug: string;
  labelKey: string;
  color: string;
}

export const STORE_TYPE_OTHER = 'other';

export const STORE_TYPES: StoreType[] = [
  { slug: 'alcohol', labelKey: 'storeType.alcohol', color: '#831F49' },
  { slug: 'bakery', labelKey: 'storeType.bakery', color: '#753226' },
  { slug: 'butcher', labelKey: 'storeType.butcher', color: '#BD001F' },
  { slug: 'coffee', labelKey: 'storeType.coffee', color: '#4A2C1A' },
  { slug: 'convenience', labelKey: 'storeType.convenience', color: '#07BDC4' },
  { slug: 'deli', labelKey: 'storeType.deli', color: '#E36A3F' },
  { slug: 'dessert', labelKey: 'storeType.dessert', color: '#EC4899' },
  { slug: 'drugstore', labelKey: 'storeType.drugstore', color: '#708238' },
  { slug: 'farmers_market', labelKey: 'storeType.farmers_market', color: '#00AA00' },
  { slug: 'grocery', labelKey: 'storeType.grocery', color: '#2B343E' },
  { slug: 'natural_foods', labelKey: 'storeType.natural_foods', color: '#C0CAAA' },
  { slug: 'seafood', labelKey: 'storeType.seafood', color: '#0F25A1' },
  { slug: STORE_TYPE_OTHER, labelKey: 'storeType.other', color: '#5b6573' },
];

export function storeTypeLabelKey(slug: string | null | undefined): string | null {
  if (!slug) return null;
  return STORE_TYPES.find((s) => s.slug === slug)?.labelKey ?? null;
}
